export const ACTIVITY_AGENDA_ROUTE_NAME = 'opportunities_activity_agenda';

export const ACTIVITY_AGENDA_PAGE_SIZE = 25;

export const ACTIVITY_AGENDA_MAX_PAGE_SIZE = 100;

export const ACTIVITY_AGENDA_REFRESH_DELAY = 1000;

export const ACTIVITY_AGENDA_RECONNECT_MAX_JITTER = 15000;

export const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch (error) {
    return undefined;
  }
};

export const formatAgendaBadgeCount = count => {
  if (!count) return '';
  return count < 100 ? `${count}` : '99+';
};

export const agendaReloadSize = loadedCount =>
  Math.min(
    Math.max(Math.ceil(loadedCount / ACTIVITY_AGENDA_PAGE_SIZE), 1) *
      ACTIVITY_AGENDA_PAGE_SIZE,
    ACTIVITY_AGENDA_MAX_PAGE_SIZE
  );

export const reconnectRefreshDelay = () =>
  Math.floor(Math.random() * ACTIVITY_AGENDA_RECONNECT_MAX_JITTER);
